import { useWidgetConfigContext } from "src/contexts/widgetConfig/WidgetConfig.context";
import { selectEnvironment } from "../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import { useAppSelector } from "./reduxHooks";

const useScroll = () => {
  const { divId } = useWidgetConfigContext();

  const scrollToAppTop = () => {
    if (!divId) return;
    const elToScrollTo = document.querySelector(`#${divId}`);
    elToScrollTo?.scrollIntoView({
      block: "start",
    });
  };

  return { scrollToAppTop };
};

export default useScroll;
